export const onKeyDownNumberWithDecimal = (event: React.KeyboardEvent<HTMLInputElement>) => {
  const regex = /[^0-9.\b]/g;

  if (
    regex.test(event.key) &&
    event.keyCode !== 8 &&
    event.keyCode !== 46 &&
    event.keyCode !== 16 &&
    event.keyCode !== 9 &&
    event.keyCode !== 37 &&
    event.keyCode !== 39
  ) {
    event.preventDefault();
  }
};

export const onKeyDownNumberOnly = (event: React.KeyboardEvent<HTMLInputElement>) => {
  const regex = /[^0-9\b]/g;

  if (
    regex.test(event.key) &&
    event.keyCode !== 8 &&
    event.keyCode !== 46 &&
    event.keyCode !== 16 &&
    event.keyCode !== 9 &&
    event.keyCode !== 37 &&
    event.keyCode !== 39
  ) {
    event.preventDefault();
  }
};

export const onKeyDownNumberOnlyAndCopyPaste = (event: React.KeyboardEvent<HTMLInputElement>) => {
  const regex = /^[0-9]$/;
  const controlKeys = [8, 46, 16, 9, 37, 39]; // Backspace, Delete, Shift, Tab, Left Arrow, Right Arrow

  // Allow Ctrl+C (copy) and Ctrl+V (paste)
  if (event.ctrlKey || event.metaKey) {
    return;
  }

  // Prevent invalid key inputs
  if (!regex.test(event.key) && !controlKeys.includes(event.keyCode)) {
    event.preventDefault();
  }
};

export const onKeyDownNumberWithFixedDecimal = (event: React.KeyboardEvent<HTMLInputElement>, precision: number) => {
  const regex = precision === 0 ? /^[0-9]|\$/ : /^[0-9]|\.$/;
  const controlKeys = [8, 46, 16, 9, 37, 39]; // Backspace, Delete, Shift, Tab, Left Arrow, Right Arrow

  // Allow Ctrl+C (copy) and Ctrl+V (paste)
  if (event.ctrlKey || event.metaKey) {
    return;
  }

  // Prevent invalid key inputs
  if (!regex.test(event.key) && !controlKeys.includes(event.keyCode)) {
    event.preventDefault();
  }

  const input = event.currentTarget.value;
  const cursorPos = event.currentTarget.selectionStart ?? 0;

  // Prevent multiple dots
  if (event.key === "." && input.includes(".")) {
    event.preventDefault();
  }

  // Prevent input beyond the allowed precision
  const decimalIndex = input.indexOf(".");
  if (
    decimalIndex !== -1 &&
    cursorPos > decimalIndex &&
    input.substring(decimalIndex + 1).length >= precision &&
    !controlKeys.includes(event.keyCode)
  ) {
    event.preventDefault();
  }
};
